import type { Hero, Characteristics } from './heroes';
import type { Option } from './stories';

export function parseHeroAgeYears(chars: Characteristics | undefined): number | null {
  const raw = chars?.age;
  if (!raw) return null;
  const match = /(\d+)/.exec(raw);
  if (!match) return null;
  const n = Number.parseInt(match[1], 10);
  return Number.isFinite(n) ? n : null;
}

export function ageYearsToGroup(years: number): string {
  if (years <= 3) return '2_3';
  if (years <= 5) return '4_5';
  return '6_8';
}

export function inferAgeGroup(heroes: Hero[], available: Option[]): string | null {
  const ages = heroes
    .map((h) => parseHeroAgeYears(h.characteristics))
    .filter((n): n is number => n !== null);
  if (ages.length === 0) return null;
  const youngest = Math.min(...ages);
  const candidate = ageYearsToGroup(youngest);
  return available.some((o) => o.value === candidate) ? candidate : null;
}
